function showVideo(value) {
  jQuery(document).ajaxComplete(function() {
    jQuery('.view-id-spritzer_gallery .view-filters .radio .js-form-item-field-tags-target-id').each(function() {
      jQuery(this).find('label').css("background-color","#e2aaa4");
    });
  
    if(value === "1") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(1) .spritzer-gallery-video").show();
      jQuery('.view-id-spritzer_gallery .view-filters .radio .js-form-item-field-tags-target-id:nth-child(2) label').css("background-color","#cb4552");
      
    } else if(value === "2") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(2) .spritzer-gallery-video").show();
      jQuery('.view-id-spritzer_gallery .view-filters .radio .js-form-item-field-tags-target-id:nth-child(3) label').css("background-color","#cb4552");
    } else if(value === "3") {
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
      jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(3) .spritzer-gallery-video").show();
      jQuery('.view-id-spritzer_gallery .view-filters .radio.js-form-item-field-tags-target-id:nth-child(4) label').css("background-color","#cb4552");
    }
  });
}

jQuery(document).ajaxComplete(function() {
  jQuery('.js-form-item-field-tags-target-id').click(function() {
    showVideo(jQuery(this).find('input').attr("value"));
  });

  jQuery('.gallery-images .js-form-item-field-tags-target-id .form-select').on('change', function() {
    switchVideo(jQuery(this).find(":selected").attr("value"));
  });
});
jQuery('.spritzer-gallery-video .play-button').on('click', function(e){
  // Remove autoplay=1 from all iframes
  jQuery('.spritzer-gallery-video').find('iframe').each(function() {
    var src = jQuery(this).attr('src');
    if (src) {
      // Remove autoplay=1 from the src if it exists
      var newSrc = src.replaceAll(/&autoplay=1/g,"");
      // Remove trailing '?' or '&' if present after autoplay=1 removal
      newSrc = newSrc.replace(/[?&]$/, '');
      jQuery(this).attr('src', newSrc);
    }
  });

  // Hide the play button and show the selected iframe
  jQuery(this).parent().hide();
  jQuery(this).parent().parent().find('iframe').show();
  jQuery(this).parent().parent().find('iframe')[0].src += "&autoplay=1";
});
//spritzer gallery page
var btn = jQuery('#button');
  jQuery(window).scroll(function () {
    if (jQuery(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function (e) {
    e.preventDefault();
    jQuery('html, body').animate({ scrollTop: 0 }, '300');
  });

jQuery(document).ready(function () {
  jQuery('.gallery-tiles').hide();
});

jQuery('.field--name-field-toggle-carousel img').click(function () {
  jQuery('.gallery-scroll').show();
  jQuery('.gallery-tiles').hide();
});

jQuery('.field--name-field-toggle-grid img').click(function () {
  jQuery('.gallery-tiles').show();
  jQuery('.gallery-scroll').hide();
});

jQuery(function() {
  jQuery('.toggle-group .field--type-image img').on('click', function() {
    jQuery('.toggle-group .field--type-image img').removeClass('active-switch');
    jQuery(this).toggleClass("active-switch");
  });
  
});

function switchVideo(value) {
  jQuery('.gallery-images .js-form-item-field-tags-target-id .form-select').each(function() {
      if(value === "1") {
    jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
    jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(1) .spritzer-gallery-video").show();
   
    
  } else if(value === "2") {
    jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
    jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(2) .spritzer-gallery-video").show();
   
  } else if(value === "3") {
    jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item .spritzer-gallery-video").hide();
    jQuery(".paragraph--type--spritzer-videos-reference .field--name-field-spritzer-videos-referencin .field__items .field__item:nth-child(3) .spritzer-gallery-video").show();
  
  }

  });

}




// WEBPACK FOOTER //
// ./js/components/_spritzer-youtube-video.js